<template>
  <div class="List">
    <Drawer
      class="common-drawer"
      title="编辑用户协议"
      v-model="showlistDrawer"
      width="40%"
      :closable="false"
      :mask-closable="false"
      :scrollable="true"
    >
      <Form
        ref="formValidate"
        :model="formData"
        :rules="ruleValidate"
        label-position="left"
        :label-width="100"
      >
        <Row :gutter="16">
          <Col span="24">
            <FormItem label="标题:" prop="title">
              <Input v-model="formData.title" placeholder="请输入" minlength="2" maxlength="20" />
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="内容:" prop="content">
              <Editor ref="editorChild" :answers="formData.content"></Editor>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="备注:" prop="remarks">
              <Input
                v-model="formData.remarks"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 5 }"
                placeholder="请输入"
              ></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div class="drawer-footer">
        <Button
          type="primary"
          @click="submitForm('formValidate')"
          :loading="btnLoading"
          >保存并发布</Button
        >
        <Button style="margin-left: 8px" @click="preview">预览</Button>
        <Button style="margin-left: 8px" @click="closeDrawer">取消</Button>
      </div>
    </Drawer>
    <div v-if="showModal">
      <UseragreementModal
        ref="useragreementModal"
        :curItemDetails="curItemDetails"
        @on-close-cancel="onCloseCancel"
      ></UseragreementModal>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import ls from "store2";
import deepcopy from "deepcopy";
import { validateActive } from "@/util/validate";
import Editor from "@/components/common/editor";
import UseragreementModal from "./useragreement-modal.vue";

export default {
  props: {
    showlistDrawer: Boolean,
    closeDrawer: Function,
    getLists: Function,
    curItemDetail: Object,
  },
  components: { Editor, UseragreementModal },
  data() {
    return {
      formData: {},
      curItemDetails: {},
      btnLoading: false,
      showModal: false,
      formValidate: {
        title: "",
        content: "",
        remarks: "",
      },
      ruleValidate: {
        title: [
          { required: true, message: "请填写标题", trigger: "blur" },
          { message: "请正确填写标题", trigger: "change", validator: this.validateTitle },
          { message: "请正确填写标题", trigger: "blur", validator: this.validateTitle }
        ],
        content: [{ required: true, message: "请填写内容", trigger: "blur" }],
      },
    };
  },
  methods: {
    // 验证
    validateTitle: function (rule, value, callback) {
      if (validateActive(value)) {
        callback(new Error('请正确填写标题'));
      } else {
        callback();
      }
    },
    preview() {
      this.curItemDetails = deepcopy(this.formData);
      this.curItemDetails.content = this.$refs.editorChild.editorContents;
      // this.showModal = true;
      // this.$emit("on-open-modal");
      ls.set("useitem", this.curItemDetails);

      const routeUrl = this.$router.resolve({
        path: `/system/agreement`,
      });

      window.open(routeUrl.href, "_blank");
    },
    onCloseCancel(bool) {
      this.showModal = bool;
    },
    submitForm(name) {
      this.formData.content = this.$refs.editorChild.editorContents;

      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$Modal.confirm({
            title: "您确定要保存并发布该协议吗？",
            content: `协议名称：${this.xss.process(this.formData.title)}`,
            onOk: () => {
              this.btnLoading = true;
              api
                .axss("post", "/ocm-admin/userAgreement/update", this.formData)
                .then((res) => {
                  if (res.code === "00000") {
                    this.$Message.success("提交成功");
                    this.btnLoading = false;
                    this.closeDrawer(); // 关闭弹窗
                    this.getLists(); // 刷新列表
                  }
                })
                .catch((error) => {
                  this.btnLoading = false;
                });
            },
            onCancel: () => {
              this.formData = {}; // 重置form
              this.closeDrawer(); // 关闭弹窗
              this.getLists(); // 刷新列表
            },
          });
        } else {
          this.$Message.error("填写信息有误");
        }
      });
    },
  },
  watch: {
    curItemDetail: {
      handler: function (newValue, oldValue) {
        this.formData = deepcopy(newValue);
        this.$refs.editorChild.editorContents = this.formData.content;
      },
      deep: true,
    },
  },
};
</script>

<style lang='less' scoped>
</style>